export const environment = {
  apiUrl: 'https://uatadmin.achagamonline.com/api/',
  imageUrl: 'https://uatadmin.achagamonline.com/',
  production: true
};
